<template>
    <div class="component-header-wrapper">
        <b-navbar class="component-header-navbar">
            <b-navbar-brand
                class="text-black font-weight-bold header-title-brand"
                v-if="title"
                href="javascript:void()"
                >{{ title }}</b-navbar-brand
            >
            <b-navbar-nav class="navbar-actions ml-auto">
                <b-modal
                    title="Select Date"
                    header-class="header-nipige-class"
                    id="dateRange"
                    size="sm"
                    ref="date-range"
                    centered
                    hide-footer
                >
                    <b-input
                        class="mb-2"
                        type="date"
                        v-model="startDate"
                    ></b-input>
                    <span
                        class="validate-error"
                        v-if="startDate && !validStartDate"
                        >Start Date is not valid</span
                    >
                    <b-input type="date" v-model="endDate"></b-input>
                    <span class="validate-error" v-if="endDate && !validEndDate"
                        >End Date is not valid</span
                    >
                    <div class="text-center mt-2">
                        <b-button
                            @click="findButtonClick()"
                            class="my -0 main-navigation-button w-47 mr-2"
                            variant="success"
                            :disabled="!validStartDate || !validEndDate"
                            >Find
                        </b-button>
                    </div>
                </b-modal>
                <b-nav-form class="header-nav-form">
                    <div
                        v-if="$slots['heading-before-search']"
                        class="heading-before-search-slot mr-2 mb-2 mb-md-0"
                    >
                        <slot name="heading-before-search"></slot>
                    </div>
                    <b-form-select
                        v-if="hasDropdown"
                        class="mr-2 mb-2 mb-md-0 header-dropdown"
                        id="type"
                        :options="hasfilterOptions"
                        :selected="computedSelectedOption"
                        v-model="computedSelectedOption"
                        @change="selectedOptionValue"
                    ></b-form-select>
                    <b-input-group-append
                        size="md"
                        class="mb-2 mb-md-0 mt-2 mt-md-0 mr-2 mr-md-2 mr-sm-0 search-group"
                        v-if="hasSearch"
                    >
                        <b-form-input
                            size="sm"
                            class="search-input height w-100"
                            placeholder="Search here"
                            v-model="searchQuery"
                            @keyup.enter="initSearch"
                        ></b-form-input>
                        <b-img
                            v-if="isSearchPerformed"
                            src="img/search_cross.png"
                            @click="handleClearSearch"
                            class="image-size"
                        ></b-img>
                        <b-img
                            v-else
                            src="img/search.png"
                            class="image-size"
                            @click="initSearch"
                        ></b-img>
                    </b-input-group-append>

                    <!-- <b-button
            v-if="hasSearch && this.$route.fullPath != '/partner'"
            size="sm"
            variant="success"
            class="my-2 mr-2 my-sm-0"
            @click="searchQuery = ''"
            >Clear</b-button
          > -->

                    <eb-select
                        v-if="hasRadio"
                        ref="dateFilterSelect"
                        type="select"
                        v-model="radioInput"
                        :selected="radioInput.text"
                        :options="radioOptions"
                        label="text"
                        id="value"
                        size="md"
                        class="select date-filter mb-2 mb-md-0"
                        :disabled="disableKey"
                        placeholder="Select Date Filter"
                        @input="radioChangeInput"
                    ></eb-select>

                    <div class="header-buttons-group">
                        <b-button
                            v-if="hasRequestList"
                            size="sm"
                            variant="info"
                            class="my-2 my-md-0 ml-0 ml-md-2 mr-2 mr-md-0 header-action-btn"
                            @click="requestList"
                            >{{ requestListButtonText }}</b-button
                        >
                        <b-button
                            v-if="hasUnbilliedInvoice"
                            size="sm"
                            variant="info"
                            class="my-2 my-md-0 ml-0 ml-md-2 mr-2 mr-md-0 header-action-btn"
                            @click="unbilliedInvoice"
                            >{{ unbilliedInvoiceText }}</b-button
                        >
                        <b-button
                            v-if="hasExport"
                            size="sm"
                            :variant="exportButtonType"
                            :class="exportButtonClasses"
                            @click="exportData"
                            >{{ exportButtonText }}</b-button
                        >
                        <b-button
                            v-if="hasCreate"
                            size="sm"
                            :variant="createButtonType"
                            class="my-2 my-md-0 ml-0 ml-md-2 mr-2 mr-md-0 header-action-btn header-create-btn"
                            @click="create"
                            >{{ createButtonText }}</b-button
                        >
                        <b-button
                            v-if="hasback"
                            size="sm"
                            :variant="backButtonType"
                            :class="[
                                'my-2 my-md-0 ml-0 ml-md-2 mr-0 mr-md-0 header-action-btn header-back-btn',
                                backButtonClass,
                            ]"
                            @click="back"
                            >{{ backButtonText }}</b-button
                        >
                        <b-button
                            v-if="hasReload"
                            size="sm"
                            class="ml-0 ml-md-2 mr-0 mr-md-0 header-action-btn header-reload-btn"
                            @click="reloadData"
                            :disabled="isLoading"
                        >
                            <span
                                v-if="isLoading"
                                class="fa fa-refresh fa-spin reload-icon"
                            >
                            </span>
                            <span
                                v-else
                                class="fa fa-refresh reload-icon"
                            ></span>
                        </b-button>
                    </div>
                    <slot name="heading-actions"></slot>
                </b-nav-form>
            </b-navbar-nav>
        </b-navbar>
    </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";
export default {
    components: {
        ebSelect,
    },
    data() {
        return {
            searchQuery: "",
            searchDebounceTimer: null,
            isSearchPerformed: false,
            radioInput: {
                text: "Today",
                value: 1,
            },
            startDate: "",
            computedSelectedOption: "",
            endDate: "",
        };
    },
    props: {
        hasfilterOptions: {
            type: Array,
            default: () => {
                [];
            },
        },
        enableOnClickSearch: {
            type: Boolean,
            default: false,
        },
        hasRadio: {
            type: Boolean,
            default: false,
        },
        disableKey: {
            type: Boolean,
            default: false,
        },
        selectedOption: {
            type: [String, Object],
        },
        radioOptions: {
            type: Array,
            default: () => {
                [];
            },
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        hasSearch: {
            type: Boolean,
            default: true,
        },
        hasCreate: {
            type: Boolean,
            default: true,
        },
        hasback: {
            type: Boolean,
            default: false,
        },
        hasExport: {
            type: Boolean,
            default: false,
        },
        hasDropdown: {
            type: Boolean,
            default: false,
        },
        hasReload: {
            type: Boolean,
            default: true,
        },
        cleanSearchOnReload: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: null,
        },
        createButtonText: {
            type: String,
            default: "Create",
        },
        backButtonText: {
            type: String,
            default: "Back",
        },
        exportButtonText: {
            type: String,
            default: "Export",
        },
        createButtonType: {
            type: String,
            default: "primary",
        },
        backButtonType: {
            type: String,
            default: "secondary",
        },
        backButtonClass: {
            type: String,
            default: "",
        },
        exportButtonType: {
            type: String,
            default: "success",
        },
        hasRequestList: {
            type: Boolean,
            default: false,
        },
        requestListButtonText: {
            type: String,
            default: "Request List",
        },
        hasUnbilliedInvoice: {
            type: Boolean,
            default: false,
        },
        unbilliedInvoiceText: {
            type: String,
            default: "Unbillied Invoice",
        },
    },
    computed: {
        validStartDate() {
            if (!this.startDate) return false;
            if (moment().diff(this.startDate, "hour") <= 0) return false;
            return true;
        },
        validEndDate() {
            if (!this.endDate) return false;
            if (moment().diff(this.endDate, "hour") <= 0) return false;
            if (moment(this.endDate).diff(this.startDate, "day") <= 0)
                return false;
            return true;
        },
        exportButtonClasses() {
            const baseClasses =
                "my-2 my-md-0 ml-0 ml-md-2 mr-2 mr-md-0 header-action-btn";
            return this.hasExport && this.$route.fullPath === "/commission"
                ? "my-2 my-md-0 mr-3 ml-0 ml-md-3 header-action-btn"
                : baseClasses;
        },
    },
    methods: {
        selectedOptionValue(e) {
            this.$emit("select-query", e);
        },
        initSearch() {
            if (this.searchQuery.length) {
                this.isSearchPerformed = true;
                this.$emit("search-query", this.searchQuery);
                if (this.enableOnClickSearch) {
                    this.$emit("onClickSearch", this.searchQuery);
                }
            }
        },
        handleClearSearch() {
            clearTimeout(this.searchDebounceTimer);
            this.searchQuery = "";
            this.isSearchPerformed = false;
            // Emit the search query as empty to "go back" to the previous data list
            this.$emit("search-query", "");
            if (this.enableOnClickSearch) {
                this.$emit("onClickSearch", "");
            }
        },
        resetSearchString() {
            this.searchQuery = "";
        },
        findButtonClick() {
            let e = {
                fromDate: this.startDate,
                toDate: this.endDate,
            };
            this.$emit("dateRangeEmit", e);
            this.$refs["date-range"].hide();
        },
        radioChangeInput() {
            let e = this.radioInput;
            if (e.value == "custom") {
                this.$nextTick(() => {
                    const selectRef = this.$refs["dateFilterSelect"];

                    if (selectRef) {
                        if (typeof selectRef.close === "function") {
                            selectRef.close();
                        } else if (selectRef.$el) {
                            const el =
                                selectRef.$el.querySelector("input") ||
                                selectRef.$el;
                            if (el && el.blur) el.blur();
                        }
                    }
                    this.startDate = null;
                    this.endDate = null;
                    this.$refs["date-range"].show();
                });
            } else {
                this.$emit("radioChangeInputEmit", e.value);
            }
        },
        create: function () {
            this.$emit("create-press");
        },
        back: function () {
            this.$emit("back-press");
        },
        requestList() {
            this.$emit("request-list-press");
        },
        unbilliedInvoice() {
            this.$emit("unbillied-invoice-press");
        },
        exportData() {
            this.$emit("onExport");
        },
        clearSearch: function () {
            this.searchQuery = "";
        },
        reloadData() {
            clearTimeout(this.searchDebounceTimer);
            this.searchQuery = "";
            this.isSearchPerformed = false;
            this.$emit("search-query", "");
            this.$emit("reload-data");
        },
    },
    watch: {
        searchQuery(newVal) {
            clearTimeout(this.searchDebounceTimer);
            this.searchDebounceTimer = setTimeout(() => {
                this.$emit("search-query", newVal);
            }, 300);
        },
        selectedOption() {
            this.computedSelectedOption = this.selectedOption;
        },
    },
    mounted() {
        this.computedSelectedOption = this.selectedOption;
    },
    beforeDestroy() {
        clearTimeout(this.searchDebounceTimer);
    },
};
</script>
<style>
.header-nipige-class {
    background-color: var(--secondary);
    border-radius: 10px 10px 0px 0px;
}
.header-nipige-class .modal-title {
    font-size: 15px;
    color: white;
    text-align: center;
}
.modal-content {
    border-radius: 10px 10px 10px 10px;
}
.image-size {
    height: 16px;
    width: 16px;
    margin-top: 0px;
    cursor: pointer;
    margin-left: -25px;
}
.date-filter {
    margin-left: 1rem;
    margin-right: 0.5rem;
}
.date-filter .vs__selected-options {
    padding: 1px 3px !important;
    width: 12rem !important;
}
input[type="date"]:after {
    content: attr(placeholder);
}
.navbar-expand {
    flex-flow: wrap !important;
}

.component-header-wrapper {
    width: 100%;
}

@media (max-width: 767.98px) {
    .component-header-wrapper {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }
}
/* Update your style section */
.search-group {
    position: relative;
    display: flex;
    align-items: center;
}

.search-input {
    height: 34.5px !important;
    border-radius: 20px;
    padding-right: 35px !important; /* Make room for the icon */
}

.search-icon-inside {
    position: absolute;
    right: 5px; /* Fixed distance from right edge */
    height: 16px;
    width: 16px;
    cursor: pointer;
    z-index: 5;
    transition: transform 0.2s;
}

.search-icon-inside:hover {
    transform: scale(1.1);
}

.component-header-navbar {
    padding: 1rem 1.5rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}

.header-title-brand {
    font-size: 1.5rem;
    margin-bottom: 0;
    width: auto;
    flex-shrink: 0;
}

.navbar-actions {
    flex: 1;
    display: flex;
    justify-content: flex-end;
}

.header-nav-form {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    width: auto;
    gap: 0.5rem;
    margin-left: auto;
}

.header-action-btn {
    flex: 0 0 auto;
    white-space: nowrap;
}

.header-create-btn,
.header-back-btn,
.header-reload-btn {
    border-radius: 8px !important;
    min-height: 34.5px;
    padding-left: 1.05rem;
    padding-right: 1.05rem;
}

.header-back-btn,
.header-reload-btn {
    color: var(--primary) !important;
    background-color: rgba(var(--primary-rgb), 0.1) !important;
    border: 1px solid rgba(var(--primary-rgb), 0.18) !important;
    box-shadow: none !important;
}

.header-back-btn:hover,
.header-back-btn:focus,
.header-reload-btn:hover,
.header-reload-btn:focus {
    color: var(--tertiary) !important;
    background-color: rgba(var(--primary-rgb), 0.18) !important;
    border-color: rgba(var(--primary-rgb), 0.28) !important;
}

.header-back-btn:not(:disabled):not(.disabled):active,
.header-back-btn:not(:disabled):not(.disabled).active,
.show > .header-back-btn.dropdown-toggle,
.header-reload-btn:not(:disabled):not(.disabled):active,
.header-reload-btn:not(:disabled):not(.disabled).active,
.show > .header-reload-btn.dropdown-toggle {
    color: var(--tertiary) !important;
    background-color: rgba(var(--primary-rgb), 0.18) !important;
    border-color: rgba(var(--primary-rgb), 0.28) !important;
}

.header-back-btn:focus,
.header-reload-btn:focus {
    box-shadow: 0 0 0 3px var(--primary-focus-ring) !important;
}

.header-reload-btn .reload-icon {
    color: var(--primary) !important;
}

.header-reload-btn:hover .reload-icon,
.header-reload-btn:focus .reload-icon {
    color: var(--tertiary) !important;
}

.header-buttons-group {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 0.5rem;
}

@media (min-width: 992px) {
    .component-header-navbar {
        flex-wrap: nowrap;
    }

    .header-title-brand {
        margin-right: auto;
    }

    .navbar-actions {
        flex: 0 0 auto;
    }

    .header-nav-form {
        flex-wrap: nowrap;
        width: auto;
    }

    .search-group {
        flex: 0 0 auto;
        width: auto;
        min-width: 250px;
        max-width: 300px;
        margin-right: 0.5rem;
    }

    .header-buttons-group {
        flex-wrap: nowrap;
    }
}

.reload-icon {
    font-size: 15px;
}

.search-group {
    position: relative;
    display: flex;
    align-items: center;
}

.search-group .input-group {
    width: 100%;
    display: flex;
    align-items: stretch;
}

.search-group > .form-control,
.search-group > input {
    flex: 1;
}

/* Ensure Bootstrap input-group-append takes full width on mobile */
@media (max-width: 767.98px) {
    .search-group.input-group-append {
        display: flex !important;
        width: 100% !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    .search-group.input-group-append .form-control {
        flex: 1 1 auto;
        width: 100% !important;
        min-width: 0;
    }
}

@media (max-width: 991.98px) {
    .component-header-navbar {
        padding: 0.75rem 0.5rem;
    }

    .header-title-brand {
        font-size: 1.25rem;
        margin-bottom: 0.75rem;
        width: 100%;
    }

    .navbar-actions {
        flex-wrap: wrap;
        width: 100% !important;
        margin-left: 0 !important;
        max-width: 100% !important;
    }

    .header-nav-form {
        flex-direction: column;
        align-items: stretch;
        width: 100% !important;
        max-width: 100% !important;
        gap: 0.75rem;
        padding-left: 0 !important;
        padding-right: 0 !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }

    .search-group {
        width: 100% !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
        margin-bottom: 0.5rem;
        display: flex !important;
        align-items: center;
        max-width: 100% !important;
        flex: 1 1 100% !important;
    }

    .search-group.input-group-append {
        width: 100% !important;
        flex: 1 1 100% !important;
    }

    .search-group .input-group {
        width: 100% !important;
        display: flex;
        align-items: stretch;
        max-width: 100% !important;
    }

    .search-group .form-control,
    .search-group input,
    .search-group .form-control-sm {
        width: 100% !important;
        flex: 1 1 auto !important;
        max-width: 100% !important;
        min-width: 0 !important;
    }

    .search-input {
        width: 100% !important;
        flex: 1 1 auto !important;
        max-width: 100% !important;
        min-width: 0 !important;
    }

    .header-dropdown {
        width: 100%;
        margin-right: 0;
        margin-bottom: 0;
        order: 2;
    }

    .date-filter,
    .date-filter .vs__dropdown-toggle,
    .date-filter .vs__selected-options {
        width: 100% !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        margin-bottom: 0;
        order: 3;
    }

    .header-buttons-group {
        order: 4;
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-top: 0.5rem;
    }

    .header-action-btn {
        flex: 1 1 0;
        min-width: 0;
        margin-left: 0 !important;
        margin-right: 0 !important;
        margin-bottom: 0;
    }
}

@media (max-width: 576px) {
    .component-header-navbar {
        padding: 0.5rem 0.5rem;
    }

    .header-title-brand {
        font-size: 1.125rem;
        margin-bottom: 0.5rem;
    }

    .header-nav-form {
        gap: 0.5rem;
    }

    .search-group {
        display: flex !important;
        align-items: center;
        width: 100% !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
        max-width: 100% !important;
        flex: 1 1 100% !important;
    }

    .search-group.input-group-append {
        width: 100% !important;
        flex: 1 1 100% !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    .search-group .input-group {
        width: 100% !important;
        display: flex;
        align-items: stretch;
        max-width: 100% !important;
    }

    .search-group .form-control,
    .search-group input,
    .search-group .form-control-sm,
    .search-group .search-input {
        width: 100% !important;
        max-width: 100% !important;
        flex: 1 1 auto !important;
        min-width: 0 !important;
    }

    .search-input {
        width: 100% !important;
        margin-right: 0;
        flex: 1 1 auto !important;
        max-width: 100% !important;
        min-width: 0 !important;
    }

    .search-group .image-size {
        margin-left: -25px;
        margin-right: 8px;
        flex-shrink: 0;
    }

    .header-nav-form {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    /* Override Bootstrap input-group-append default styles */
    .search-group.input-group-append .input-group-text,
    .search-group.input-group-append > *:not(.form-control):not(input) {
        flex: 0 0 auto;
    }

    .header-dropdown {
        order: 2;
        margin-bottom: 0.5rem;
    }

    .date-filter {
        order: 3;
        margin-bottom: 0.5rem;
    }

    /* Action buttons - horizontal row */
    .header-buttons-group {
        order: 4;
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 0.5rem;
        margin-top: 0.5rem;
    }

    .header-action-btn {
        flex: 1 1 0;
        min-width: 0;
        margin-left: 0 !important;
        margin-right: 0 !important;
        margin-bottom: 0;
        white-space: nowrap;
    }

    /* Ensure buttons are in a row and evenly spaced */
    .header-nav-form {
        flex-direction: column;
        align-items: stretch;
    }
}
</style>
